import { createRootModal } from '../../RootModal';
import CloseCardBody from './CloseCardBody';
import CloseCardFooter from './CloseCardFooter';

const CloseCard = createRootModal(CloseCardBody, {
	config: {
		isHeaderWithColorBgAndIcon: true,
		title: 'Close card',
		subtitle: 'Learn about close card',
		headerBackgroundColor: 'rgb(var(--red))',
		headerIcon: 'XMARK_CIRCLE_FILL',
		isOpen: true,
		height: '70%',
	},
	footerComponent: CloseCardFooter,
});

export default CloseCard;
